export default __webpack_public_path__ + "static/media/img-slider-dlttaxi-3.262b1252.png";